import {CommandRequester} from '../../../CommandRequester';
import {
    Config as ConfigRequester,
    GetConfigToken,
    SetConfigToken,
} from './requesters/Config';

/**
 * Commands for working with Jibo's settings and configurations
 * @namespace CommandRequester.config
 */
export class Config {

    private configRequester: ConfigRequester;

    constructor(requester:CommandRequester) {
        this.configRequester = new ConfigRequester(requester);
    }

    /**
     * Get robot configuration options.
     * @method CommandRequester.config#get
     * @return {GetConfigToken}
     */
    public get(): GetConfigToken {
        const protocol = ConfigRequester.generateProtocol() as JIBO.v1.GetConfigRequest;
        return this.configRequester.generateToken(protocol, true) as GetConfigToken;
    }

    /**
     * Set robot configuration options.
     * @method CommandRequester.config#set
     * @param  {CommandRequester.config.SetConfigOptions}  options Options for settable configurations
     * @return {SetConfigToken}
     */
    public set(options: CommandRequester.config.SetConfigOptions): SetConfigToken {
        const protocol = ConfigRequester.generateProtocol({
            Mixer: options.mixer,
        }) as JIBO.v1.SetConfigRequest;
        return this.configRequester.generateToken(protocol, true) as SetConfigToken;
    }
}